import React, { useContext, useState, useEffect } from 'react'
import { AppContext } from './../../providers'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  Step,
  Menu,
  Dropdown,
  Input,
} from 'semantic-ui-react'
import { adminRole, designerRole, copyRole } from './../../config/roles'
import { templateLanguages } from './../../config/templateLanguages'

const ToolBarActions = ({ id, product, row, template, isCoedit, isConverting }) => {
  const { beeAPI, eventAPI } = useContext(AppContext)
  const { store, dispatch } = beeAPI
  const [joinURL, setJoinURL] = useState('')
  const { config } = store

  useEffect(() => {
    const root = 'https://bee-plugin-demos.getbee.io/#'
    setJoinURL(`${root}/message/${product}/${id}/coedit/${store?.sessionId}`)
  }, [product, id, store, store.sessionId])

  const save = (event, mode, isPrompt) => {
    console.log('save')
    const { enqueue } = eventAPI
    enqueue({
      name: 'saveMessage',
      mode: mode !== 'undefined' ? mode : 'row',
      id: id || row,
      isPrompt,
    })
    store.instance && store.instance.save()
  }

  const savetofile = () => {
    console.log('savetofile')
    const { enqueue } = eventAPI
    enqueue({
      name: 'exportHTML'
    })
    store.instance && store.instance.save()
  }

  const customPreview = () => {
    console.log('customPreview')
    const { enqueue } = eventAPI
    enqueue({
      name: 'customPreview'
    })
    store.instance && store.instance.save()
  }

  const preview = () => {
    store.instance && store.instance.preview()
  }

  const pdf = () => {
    store.instance && store.instance.send()
  }

  const pause = (duration) => {
    return new Promise((resolve) => setTimeout(resolve, duration))
  }

  const switchTemplateLanguage = async (lang) => {
    if (lang != 'default') {
      const newConfig = {
        ...templateLanguages,
        templateLanguageAutoTranslation: true,
      }
      store.instance && store.instance.loadConfig(newConfig)
      await pause(1000)
      store.instance && store.instance.switchTemplateLanguage({ language: lang.value })
      store.instance.translateTemplate({ language: lang.value })
    } else {
      dispatch({
        payload: {
          config: {
            ...config,
          },
        }
      })
    }
  }

  const handleCopy = (text, result) => {
    console.log('copied text', text)
    console.log('copied result', result)
  }

  const handleChangeRoleTemplate = (role) => {
    let roleTemplate = {}

    switch (role) {
      case 'admin':
        roleTemplate = {
          ...adminRole,
        }
        break
      case 'designer':
        roleTemplate = {
          ...designerRole
        }
        break
      case 'copy':
        roleTemplate = {
          ...copyRole,
        }
        break
      default:
        break
    }
    dispatch({
      payload: {
        config: {
          ...config,
          ...roleTemplate,
        },
      }
    })
  }

  return (
    <Step.Group fluid size='mini'>
      <Menu secondary size='small'>
        <Menu.Menu position='right'>
          <Dropdown item text="Actions">
            <Dropdown.Menu>
              {
                !template && !isConverting && (
                  <Dropdown.Item onClick={(e) => save(e, `${product}`)} text="Save" />
                )
              }
              {
                product !== 'popup' && (
                  <Dropdown item text="Save As" className="rightDropdown">
                    <Dropdown.Menu>
                      <Dropdown.Item icon='mail' onClick={(e) => save(e, 'email', true)} text="Email" />
                      <Dropdown.Item icon='html5' onClick={(e) => save(e, 'page', true)} text="Page" />
                    </Dropdown.Menu>
                  </Dropdown>
                )
              }
              <Dropdown item text="Preview" className="rightDropdown">
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => preview()} icon='laptop' text='Device Preview' />
                  <Dropdown.Item onClick={() => customPreview()} icon='file code outline' text='Custom Preview' />
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown item text="Export" className="rightDropdown">
                <Dropdown.Menu>
                  <Dropdown.Item icon='html5' onClick={() => savetofile()} text="HTML" />
                  <Dropdown.Item icon='file pdf' onClick={() => pdf()} text="PDF" />
                </Dropdown.Menu>
              </Dropdown>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown item text="Roles">
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleChangeRoleTemplate('admin')} text='Admin' />
              <Dropdown.Item onClick={() => handleChangeRoleTemplate('designer')} text='Designer' />
              <Dropdown.Item onClick={() => handleChangeRoleTemplate('copy')} text='Copywriter' />
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown item text="Translate">
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => switchTemplateLanguage('default')} content={<>Default</>} />
              <Dropdown.Item onClick={() => switchTemplateLanguage({ value: 'en-US', label: 'English' })} content={<>English</>} />
              <Dropdown.Item onClick={() => switchTemplateLanguage({ value: 'it-IT', label: 'Italiano' })} content={<>Italian</>} />
              <Dropdown.Item onClick={() => switchTemplateLanguage({ value: 'fr-FR', label: 'Français' })} content={<>Français</>} />
            </Dropdown.Menu>
          </Dropdown>
          {
            isCoedit && store?.sessionId && (
              <CopyToClipboard text={joinURL} onCopy={handleCopy}>
                <Dropdown item text='Co-edit'>
                  <Dropdown.Menu>
                    <Dropdown.Header icon='share alternate' content='Share this session' />
                    <Input
                      action={{
                        onClick: () => { },
                        labelPosition: 'right',
                        icon: 'copy',
                        content: 'Copy',
                      }}
                      value={joinURL}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </CopyToClipboard>
            )
            /*
              <Menu.Item onClick={() => toggleStructure()}>Structure</Menu.Item>
              <Menu.Item onClick={() => clear()}>Clear Canvas</Menu.Item>
            */
          }
        </Menu.Menu>
      </Menu>
    </Step.Group>
  )
}

export default ToolBarActions
